import { defineMessages } from 'react-intl';

export default defineMessages({
  clinicCoordinator: 'Koordynator placówki',
});
